import { ReactNode } from 'react';

import styled from '@emotion/styled';

import COLOR from '../../../../../shared/constant/colorset';

const Container = styled.dl`
  display: flex;
  flex: 1;
  flex-direction: row;
  align-items: flex-start;
  overflow: hidden;
  width: 100%;
  padding: 17px 0 18px;
  border-top: 1px solid ${COLOR.bg};
  font-size: 14px;
  letter-spacing: -0.5px;
`;

const Title = styled.dt`
  position: relative;
  top: 1px;
  width: 128px;
  height: 100%;
  color: ${COLOR.kurlyGray600};
  line-height: 19px;
`;

interface Props {
  title: string;
  className?: string;
  children: ReactNode;
}

export default function ListItem({
  title,
  className,
  children,
}: Props) {
  return (
    <Container className={className}>
      <Title className="title">
        {title}
      </Title>
      {children}
    </Container>
  );
}
